<div class="row border py-3 rounded m-0">
  <div class="col-md-auto">
    <strong>MRN</strong>
    <div class="phi">{{ task.patient.mrn }}</div>
    @if (displayUserPresence) {
      <app-user-presence category="clientConsultNoteTask" [targetId]="task.id" />
    }
  </div>
  <div class="col-md-auto">
    <strong>Patient Name</strong>
    <div class="phi">{{ task.patient.fullName }}</div>
    <app-patient-alternate-names [patient]="task.patient" />
  </div>
  <div class="col-md-auto">
    <strong>DOB</strong>
    <div class="phi">{{ task.patient.dob | date: 'MM/dd/yyyy' }}</div>
  </div>
  <div class="col-md-auto">
    <strong>Task Type</strong>
    <div>{{ task.humanizedType }}</div>
  </div>
  <div class="col-md-auto text-center">
    <strong>Prescriptions Verified</strong>
    <div>{{ task.verifiedPrescriptionsCount | number }} / {{ task.prescriptionsCount | number }}</div>
  </div>
  <div class="col-md-auto">
    <strong>Value</strong>
    <div><app-task-estimated-value [rank]="task.estimatedValueRank" [value]="task.estimatedValue" /></div>
  </div>
  <div class="col-md-2">
    @if (task.status === consultNoteTaskStatuses.closed) {
      <app-client-consult-note-task-closed
        [task]="task"
        />
    } @else {
      <strong>Status</strong>
      <div>{{ task.status | taskStatus }}</div>
    }
  </div>
  <div class="col-md-auto">
    @if (task.flaggedForEsp) {
      <div class="alert alert-danger my-3 p-1 text-center">ESP</div>
    }
  </div>
</div>
